module.exports = __webpack_public_path__ + "static/media/12.jpg.a84d2d3f.webp";